/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum LineStyle {
	Solid = 0,
	Dashed = 1,
}
